import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentsModule} from '../../../components/components.module';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TableModule} from 'primeng/table';
import {TagModule} from 'primeng/tag';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CheckboxModule} from 'primeng/checkbox';
import {InputTextModule} from 'primeng/inputtext';
import {TextareaModule} from 'primeng/textarea';
import {DropdownModule} from 'primeng/dropdown';
import {DialogModule} from 'primeng/dialog';
import {CampaignComponent} from './campaign.component';
import {CampaignEditComponent} from './campaign-edit/campaign-edit.component';
import {TranslateModule} from '@ngx-translate/core';
import {DatePickerModule} from "primeng/datepicker";
import {InputNumberModule} from "primeng/inputnumber";
import { CampaignDetailComponent } from './campaign-detail/campaign-detail.component';
import {RippleModule} from "primeng/ripple";
import { PipesModule } from '../../../pipes/pipes.module';
import {SelectButtonModule} from 'primeng/selectbutton';
import {AccordionModule} from 'primeng/accordion';
import {MenuModule} from 'primeng/menu';
import {TooltipModule} from 'primeng/tooltip';
import {MultiSelectModule} from 'primeng/multiselect';
import {AutoCompleteModule} from 'primeng/autocomplete';


@NgModule({
    declarations: [CampaignComponent, CampaignEditComponent, CampaignDetailComponent],
    imports: [
        CommonModule,
        ComponentsModule,
        ButtonModule,
        ToastModule,
        ConfirmDialogModule,
        TableModule,
        TagModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CheckboxModule,
        InputTextModule,
        TextareaModule,
        DropdownModule,
        DialogModule,
        TranslateModule,
        DatePickerModule,
        InputNumberModule,
        RippleModule,
        PipesModule,
        SelectButtonModule,
        AccordionModule,
        MenuModule,
        TooltipModule,
        MultiSelectModule,
        AutoCompleteModule
    ]
})
export class CampaignModule {
}
